var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9028_72640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 28.875V26.125C22.5 24.6663 21.9205 23.2674 20.8891 22.2359C19.8576 21.2045 18.4587 20.625 17 20.625H7.375C5.91631 20.625 4.51736 21.2045 3.48591 22.2359C2.45446 23.2674 1.875 24.6663 1.875 26.125V28.875",
    stroke: "#656565",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 16.125C15.2251 16.125 17.6875 13.6626 17.6875 10.625C17.6875 7.58743 15.2251 5.125 12.1875 5.125C9.14993 5.125 6.6875 7.58743 6.6875 10.625C6.6875 13.6626 9.14993 16.125 12.1875 16.125Z",
    stroke: "#656565",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 11V19.25",
    stroke: "#656565",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.125 15.125H22.875",
    stroke: "#656565",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9028_72640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user-plus.35d09a47d82018272f2c8ae0f9b254c0.svg";
export { ForwardRef as ReactComponent };